import { render, staticRenderFns } from "./_inputNumber.vue?vue&type=template&id=24ca5d22"
import script from "./_inputNumber.vue?vue&type=script&lang=js"
export * from "./_inputNumber.vue?vue&type=script&lang=js"
import style0 from "./_inputNumber.vue?vue&type=style&index=0&id=24ca5d22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports